import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { CompensationBonusData } from '../../../core/compensation-bonus-data.model';
import { ScorecardDataService } from '../../../core/data.service';
import { Widget, WidgetType } from '../../../core/template-definition.model';
import { CMPS_SCORECARD_WIDGET } from '../../../scorecard.metadata';
import { TranslationKeyMap } from '../../pulse-widget.i18n';

@Component({
    selector: 'cmps-bonus-pulse-widget',
    templateUrl: './bonus-pulse-widget.component.html',
})
@TakeUntilDestroy()
export class ScBonusWidgetComponent implements OnInit, OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;
    /** @private */ _data: CompensationBonusData;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Optional()
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */
        public _widget: Widget,
    ) {}

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<CompensationBonusData>(
                WidgetType.COMPENSATION_BONUS,
            )
            .pipe(
                tap((data) => {
                    this._data = data;
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        //
    }
}
